export default __webpack_public_path__ + "static/media/heart_pink.a80a827e.svg";